import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export interface FileListItemClasses {
  /**
   * CSS class applied to the root slot `ListItem` element of a <FileListItem> component.
   */
  root: string;
  /**
   * CSS class applied to the root slot element of a <FileListItem> component when the uploadPercentComplete prop does not have a value of 100.
   */
  fileStatusUploading: string;
  /**
   * CSS class applied to the root slot element of a <FileListItem> component when the errors prop is a non-empty list of `FileError`s.
   */
  fileStatusUploadError: string;
  /**
   * CSS class applied to the root slot element of a <FileListItem> component when the uploadPercentComplete prop has a value of 100 and the errors prop is undefined or empty.
   */
  fileStatusUploadSuccess: string;

  /**
   * CSS class applied to the file name slot Typography element within a <FileListItem> component.
   */
  fileName: string;
  /**
   * CSS class applied to the file error slot Typography element within a <FileListItem> component.
   */
  fileErrorMessage: string;
  /**
   * CSS class applied to the file icon slot Icon element within a <FileListItem> component.
   */
  fileIcon: string;

  /**
   * CSS class applied to the meta slot element within a <FileListItem> component.
   */
  fileMeta: string;
  /**
   * CSS class applied to the meta slot element within a <FileListItem> component when the file is being uploaded.
   */
  fileMetaFileUploadStatus: string;
  /**
   * CSS class applied to the meta slot element within a <FileListItem> component when the file is done being uploaded, and the `showFileSize` prop is true.
   */
  fileMetaFileSize: string;
}

export type FileListItemClassKey = keyof FileListItemClasses;

export function getFileListItemUtilityClass(slot: string): string {
  return generateUtilityClass('UnifyFileListItem', slot);
}

const fileListItemClasses: FileListItemClasses = generateUtilityClasses(
  'UnifyFileListItem',
  [
    'root',
    'fileName',
    'fileErrorMessage',
    'fileIcon',
    'fileSize',
    'fileStatusUploading',
    'fileStatusUploadError',
    'fileStatusUploadSuccess',
    'fileMeta',
    'fileMetaFileUploadStatus',
    'fileMetaFileSize',
  ]
);

export default fileListItemClasses;
